/* Permitido adicionar novos valores apenas se estiverem presentes na tabela de taxonomia
https://docs.google.com/spreadsheets/d/1dTq-dLf_q3_FjXGWk3RTgmHDJxRvfXxTQoeRwxJykyg/edit#gid=1951505218
*/

export enum System {
  HOTMART_CLUB = 'hotmart_club',
  HOTMART_HUB = 'hotmart_hub',
  HOTMART_PLATAFORM = 'hotmart_plataform'
}

export enum Entity {
  ADMIN = 'admin',
  HOME = 'home',
  SEARCH = 'search',
  PROFILE = 'profile',
  PRODUCT_CONSUME = 'product_consume',
  COMMUNITY = 'community'
}

export enum Action {
  CLICK_OPEN_PROFILE = 'click_open_profile',
  CLICK_OPEN_MESSAGE_BOX = 'click_open_message_box',
  CLICK_POST_DETAIL = 'click_post_detail',
  TRY_CREATE_REACT_POST = 'try_create_react_post',
  TRY_READ_ACTIVITIES = 'try_read_activities',
  TRY_LOAD_HIGHLIGHTS = 'try_load_highlights',
  CLICK_ACCESS_CLASS = 'click_access_class',
  CLICK_ACCESS_COMMUNITY = 'click_access_community'
}

export enum Platform {
  WEB = 'WEB'
}

export enum ClubVersion {
  OLD_CLUB_MIDNIGHT = 'OLD_CLUB_MIDNIGHT',
  OLD_CLUB_CLASSIC = 'OLD_CLUB_CLASSIC',
  MEMBERSHIP = 'MEMBERSHIP'
}

export enum UserRole {
  OWNER = 'OWNER',
  MODERATOR = 'MODERATOR',
  ADMIN = 'ADMIN',
  CONSUMER = 'CONSUMER',
  VIEWER = 'VIEWER'
}

export enum CommunityType {
  PUBLIC = 'PUBLIC',
  PAID = 'PAID',
  PRIVATE = 'PRIVATE',
  PREMIUM = 'PREMIUM'
}

export enum ConnectionStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE'
}

export enum TryResult {
  SUCCESSFUL = 'SUCCESSFUL',
  FAILURE = 'FAILURE'
}

export enum ComponentName {
  CLUB_PROFILE = 'CLUB_PROFILE',
  UPPER_RIGHT_MENU = 'UPPER_RIGHT_MENU',
  MEMBER_RANK = 'MEMBER_RANK',
  POST_FEED = 'POST_FEED',
  POST_LIST = 'POST_LIST',
  SIDEBAR_RELATED_POST = 'SIDEBAR_RELATED_POST',
  TRENDING_POSTS = 'TRENDING_POSTS',
  POST_PAGE = 'POST_PAGE',
  POST_COMMENT = 'POST_COMMENT',
  CLASS_COMMENT = 'CLASS_COMMENT',
  HIGHLIGHTS_SECTION = 'HIGHLIGHTS_SECTION'
}

export enum ComponentSource {
  POST_REACTION = 'POST_REACTION',
  POST_LIST = 'POST_LIST',
  COMMENT = 'COMMENT_LIST',
  COURSE_LIST = 'COURSE_LIST',
  COMMUNITY_LIST = 'COMMUNITY_LIST',
  HIGHLIGHTS_SECTION = 'HIGHLIGHTS_SECTION'
}

export enum ProfileType {
  MY_PROFILE = 'MY_PROFILE',
  SOMEONE_PROFILE = 'SOMEONE_PROFILE'
}

export enum ContentType {
  POST = 'POST',
  COMMENT = 'COMMENT',
  COURSE = 'COURSE',
  COMMUNITY = 'COMMUNITY'
}
